import * as Yup from "yup";

export const bannerFormSchema = Yup.object().shape({
  platform: Yup.string().required("Platform is required"),
  screen: Yup.string().required("Screen Page is required"),
  position: Yup.string().required("Position is required"),
  banners: Yup.array().required("Banner is required"),
});
